import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col, Glyphicon } from "react-bootstrap";
import ProductQuantity from "../../common/product/product-quantity";
import {
  basketUpdateLineItem,
  deleteFromBasket,
  getOrderToConfirm,
} from "../../../actions/orders";
import "./styles.css";

class BasketRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showBasket: false,
      product: {},
      product_qty: 0,
      line_total: 0,
    };
  }

  componentWillMount() {
    this.setState({
      product: this.props.basket[this.props.id].product,
      product_qty: this.props.basket[this.props.id].product_qty,
      line_total: this.props.basket[this.props.id].line_total,
    });
  }

  addToBasket(event) {
    this.setState(
      {
        product_qty: parseInt(event.target.value),
      },
      () => {
        this.props
          .dispatch(
            basketUpdateLineItem(
              this.props.basket[this.state.product.id],
              this.state.product_qty
            )
          )
          .then(() => {
            if (this.props.isOnConfirm) {
              this.props.dispatch(getOrderToConfirm());
            }
          });
      }
    );
  }

  removeFromBasket = () => {
    this.props
      .dispatch(deleteFromBasket(this.props.basket[this.state.product.id]))
      .then(() => {
        if (this.props.isOnConfirm) {
          this.props.dispatch(getOrderToConfirm());
        }
      });
  };

  render() {
    const lineItem = this.props.basket[this.state.product.id];
    const isPromotionAvailable = lineItem.promotion_is_available;

    return (
      <div className="basket-row">
        <Row>
          <Col sm={3} xs={2} className="basket-col-image">
            <img
              className="basket-image"
              src={lineItem.product.links.image}
              alt="Product"
            />
          </Col>
          <Col sm={9} xs={10} className="basket-row-info">
            <Row>
              <Col xs={10} className="product-name">
                <h4>{lineItem.product.name}</h4>
              </Col>
              <Col xs={2} className="remove-icon">
                <Glyphicon glyph="trash" onClick={this.removeFromBasket} />
              </Col>
            </Row>
            <Row>
              <Col sm={2} xs={3} className="prize">
                {isPromotionAvailable ? <span className="main">
                  (€{lineItem.product.outer_price.toFixed(2)}) 
                  €{lineItem.product.current_promotion.outer_price.toFixed(2)}
                </span> : 
                <span className="main">
                  €{lineItem.product.outer_price.toFixed(2)}
                </span>}
              </Col>
              <Col sm={5} xs={4}>
                <ProductQuantity
                  id={lineItem.product.id}
                  value={lineItem.product_qty}
                  min="1"
                  handleChange={this.addToBasket.bind(this)}
                  showLabel={true}
                />
              </Col>
              <Col xs={5} className="prize">
                {isPromotionAvailable ? <span className="total h4">
                  (€{lineItem.line_total.toFixed(2)}) €{lineItem.total_with_current_promotion.toFixed(2)}
                </span> :
                <span className="total h4">€{lineItem.line_total.toFixed(2)}</span>}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            {this.props.errors && this.props.errors[lineItem.id] && (
              <div className="errors">
                <span>{this.props.errors[lineItem.id]}</span>
              </div>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    basket: state.orders.new.basket.line_items,
    errors: state.orders.new.basket_errors,
  };
};

export default connect(mapStateToProps)(BasketRow);



// WEBPACK FOOTER //
// ./src/components/new-order/basket/basket-row.jsx